import {
  NBS_API_GET_LIST_ADS_SUCCESS
} from '../../constants/actions';

const initialState = {};

export default function reducer (state = initialState, action = {}) {
  let data;

  switch (action.type) {
    case NBS_API_GET_LIST_ADS_SUCCESS:
      let old = (state[`${action.refList}`] && state[`${action.refList}`]['data']) || [];
      data = [...old, ...action.response.records];

      return {
        ...state,
        [`${action.refList}`]: {
          lastFetched: Date.now(),
          data,
          count: data.length
        }
      };
    default:
      return state;
  }
}
